// Import Core Components here
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

// Import App depedency here
import { Input } from "arv-reactcomponents";

class AccountRadioTypeInput extends Component {
  constructor(props) {
    super(props);

    this.toggleValue = this.toggleValue.bind(this);
  }

  toggleValue(e) {
    if (e.key && e.key !== "Enter") {
      return;
    }
    this.props.handleToggle();
  }

  render() {
    const { checked, name, className, ...otherProps } = this.props;
    return (
      <Fragment>
        <Input
          name={name}
          type="radio"
          value="0"
          checked={checked}
          className={`nwc-inp-radio-primary nwc-inp-normal ${className}`}
          onChange={this.toggleValue}
          onKeyDown={this.toggleValue}
          {...otherProps}
        />
      </Fragment>
    );
  }
}

AccountRadioTypeInput.defaultProps = {
  className: "",
};

AccountRadioTypeInput.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: AccountRadioTypeInput,
  component: AccountRadioTypeInput,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/AccountRadioTypeInput/index.js